import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html'
})
export class BreadcrumbComponent {

  private breadcrumb = new Array<string>();
  private currentUrl = [];
  private goToUrl: string;
  public arrayString = new Array<string>();
  public urlString = ' ';

  constructor(private router: Router) { }

  public get currentBreadcrumb() {
    this.breadcrumb = [];
    this.currentUrl = this.router.url.toString().split('/');
    if (this.currentUrl[1] !== 'home') {
      this.currentUrl[0] = 'home';
    } else {
      this.currentUrl.shift();
    }
    this.currentUrl.forEach(element => {
      if (element.includes('-')) {
        this.arrayString = element.split('-');
        element = ' ';
        for (let word of this.arrayString) {
          let wordUpper = word.charAt(0).toUpperCase() + word.slice(1);
          if (wordUpper.includes('ny')) {
            const index = wordUpper.indexOf('ny');
            wordUpper = wordUpper.substring(0, index) + 'ñ' + wordUpper.substring(index + 2);
          }
          element += wordUpper + ' ';
        }
      }
      this.breadcrumb.push(element.charAt(0).toUpperCase() + element.slice(1));
    });
    return this.breadcrumb;
  }

  public goTo(optionBreadcrumb: string) {
    this.goToUrl = '';
    if (optionBreadcrumb !== '0' && this.currentUrl.length > 0 && this.currentUrl[0] === 'home') {
      this.currentUrl.shift();
    }
    const indexOptionBreadcrumb: number = this.currentUrl.indexOf(optionBreadcrumb);
    this.currentUrl.forEach(urlPart => {
      const indexUrlPart: number = this.currentUrl.indexOf(urlPart);
      if (indexUrlPart <= indexOptionBreadcrumb) {
        this.goToUrl += urlPart + '/';
      }
    });
    return this.goToUrl;
  }

}
